import { eNotificationSeverity } from 'shared-grpc-api/shared/domains/vlp-notification/vlp-notification-definition-model';
export { eNotificationSeverity };
import { eAlertIncidentState } from 'shared-grpc-api/shared/domains/vlp-notification/vlp-notification-delivery-model';
export { eAlertIncidentState };
// LUL-653 — Notification models (PascalCase) mapped from protobuf-ts DTOs (camelCase)
// of NotificationAdminGrpcService: persistent inbox item, catalog definition/rule, incident.

import { tsToDate } from "shared-domains/domains/base.model";
import { toTimestamp } from "shared-domains/utilities/grpc-convert.helper";

export class NotificationMailProfileModel {
    public NotificationMailProfileId = 0;
    public TenantId = 0;
    public OrganizationUnitId = 0;
    public DisplayName = "";
    public Transport = 1;
    public Host = "";
    public Port = 587;
    public SecurityMode = 1;
    public Username = "";
    public FromAddress = "";
    public FromName = "";
    public ReplyTo = "";
    public HasStoredCredential = false;
    public Enabled = true;
    public LastTestedAt: Date | null = null;
    public LastTestStatus = "";
    public LastErrorCode = "";
    public EffectiveForScope = false;
    public Active = true;
    public Archive = false;
    public Description = "";

    constructor(dto?: any) {
        if (!dto) return;
        this.NotificationMailProfileId = Number(dto.notificationMailProfileId ?? dto.NotificationMailProfileId ?? 0);
        this.TenantId = Number(dto.tenantId ?? dto.TenantId ?? 0);
        this.OrganizationUnitId = Number(dto.organizationUnitId ?? dto.OrganizationUnitId ?? 0);
        this.DisplayName = dto.displayName ?? dto.DisplayName ?? "";
        this.Transport = Number(dto.transport ?? dto.Transport ?? 1);
        this.Host = dto.host ?? dto.Host ?? "";
        this.Port = Number(dto.port ?? dto.Port ?? 587);
        this.SecurityMode = Number(dto.securityMode ?? dto.SecurityMode ?? 1);
        this.Username = dto.username ?? dto.Username ?? "";
        this.FromAddress = dto.fromAddress ?? dto.FromAddress ?? "";
        this.FromName = dto.fromName ?? dto.FromName ?? "";
        this.ReplyTo = dto.replyTo ?? dto.ReplyTo ?? "";
        this.HasStoredCredential = !!(dto.hasStoredCredential ?? dto.HasStoredCredential);
        this.Enabled = dto.enabled ?? dto.Enabled ?? true;
        this.LastTestedAt = tsToDate(dto.lastTestedAt ?? dto.LastTestedAt);
        this.LastTestStatus = dto.lastTestStatus ?? dto.LastTestStatus ?? "";
        this.LastErrorCode = dto.lastErrorCode ?? dto.LastErrorCode ?? "";
        this.EffectiveForScope = !!(dto.effectiveForScope ?? dto.EffectiveForScope);
        this.Active = dto.active ?? dto.Active ?? true;
        this.Archive = !!(dto.archive ?? dto.Archive);
        this.Description = dto.description ?? dto.Description ?? "";
    }

    toDto(): any {
        return {
            notificationMailProfileId: this.NotificationMailProfileId,
            tenantId: this.TenantId,
            organizationUnitId: this.OrganizationUnitId,
            displayName: this.DisplayName,
            transport: this.Transport,
            host: this.Host,
            port: this.Port,
            securityMode: this.SecurityMode,
            username: this.Username,
            fromAddress: this.FromAddress,
            fromName: this.FromName,
            replyTo: this.ReplyTo,
            hasStoredCredential: this.HasStoredCredential,
            enabled: this.Enabled,
            lastTestedAt: toTimestamp(this.LastTestedAt),
            lastTestStatus: this.LastTestStatus,
            lastErrorCode: this.LastErrorCode,
            effectiveForScope: this.EffectiveForScope,
            active: this.Active,
            archive: this.Archive,
            description: this.Description,
        };
    }
}
export class NotificationInboxTypeOption {
    public DefinitionCode = "";
    public DisplayName = "";

    constructor(dto?: any) {
        if (!dto) return;
        this.DefinitionCode = dto.definitionCode ?? "";
        this.DisplayName = dto.displayName ?? this.DefinitionCode;
    }
}

const SEVERITY_STYLES: Record<number, string> = {
    1: "bg-red-100 text-red-800",
    2: "bg-orange-100 text-orange-800",
    3: "bg-amber-100 text-amber-800",
    4: "bg-blue-100 text-blue-800",
};

const SEVERITY_LABELS: Record<number, string> = { 1: "P1", 2: "P2", 3: "P3", 4: "P4" };

/** Một item trong inbox người dùng = message + delivery in-app (IsRead) của chính account. */
export class NotificationInboxItem {
    public TenantId = 0;
    public NotificationDeliveryId = 0;
    public NotificationMessageId = 0;
    public DefinitionCode = "";
    public Severity: eNotificationSeverity = eNotificationSeverity.NOTIFICATION_SEVERITY_P4_INFO;
    public Title = "";
    public Content = "";
    /** Deep-link đối tượng nghiệp vụ (AC 7). */
    public SubjectId = 0;
    public SubjectType = "";
    public IsRead = false;
    public CreatedAt: Date | null = null;

    constructor(messageDto?: any, deliveryDto?: any) {
        if (messageDto?.notificationDeliveryId && !deliveryDto) {
            deliveryDto = messageDto;
        }
        if (messageDto) {
            this.TenantId = Number(messageDto.tenantId ?? 0);
            this.NotificationMessageId = Number(messageDto.notificationMessageId ?? 0);
            this.DefinitionCode = messageDto.definitionCode ?? "";
            this.Severity = Number(messageDto.severity ?? eNotificationSeverity.NOTIFICATION_SEVERITY_P4_INFO);
            this.Title = messageDto.title ?? "";
            this.Content = messageDto.contentSnapshot ?? "";
            this.SubjectId = Number(messageDto.subjectId ?? 0);
            this.SubjectType = messageDto.subjectType ?? "";
            this.CreatedAt = tsToDate(messageDto.createdAt);
        }
        if (deliveryDto) {
            this.NotificationDeliveryId = Number(deliveryDto.notificationDeliveryId ?? 0);
            this.IsRead = !!deliveryDto.isRead;
        }
    }

    get SeverityLabel(): string { return SEVERITY_LABELS[this.Severity] ?? ""; }
    get SeverityStyle(): string { return SEVERITY_STYLES[this.Severity] ?? "bg-gray-100 text-gray-700"; }

}

export class NotificationDefinitionModel {
    public NotificationDefinitionId = 0;
    public Code = "";
    public Title = "";
    public Category = 0;
    public Severity: eNotificationSeverity = eNotificationSeverity.NOTIFICATION_SEVERITY_P4_INFO;
    public OwnerTeam = "";
    public Mandatory = false;
    public RunbookUrl = "";
    public Version = 1;

    constructor(dto?: any) {
        if (!dto) return;
        this.NotificationDefinitionId = Number(dto.notificationDefinitionId ?? 0);
        this.Code = dto.code ?? "";
        this.Title = dto.title ?? "";
        this.Category = Number(dto.category ?? 0);
        this.Severity = Number(dto.severity ?? 0);
        this.OwnerTeam = dto.ownerTeam ?? "";
        this.Mandatory = !!dto.mandatory;
        this.RunbookUrl = dto.runbookUrl ?? "";
        this.Version = Number(dto.version ?? 1);
    }

    get SeverityLabel(): string { return SEVERITY_LABELS[this.Severity] ?? ""; }
}

export class AlertIncidentModel {
    public AlertIncidentId = 0;
    public DefinitionCode = "";
    public Severity: eNotificationSeverity = eNotificationSeverity.NOTIFICATION_SEVERITY_P3_WARNING;
    public Summary = "";
    public State: eAlertIncidentState = eAlertIncidentState.ALERT_INCIDENT_STATE_OPEN;
    public EscalationLevel = 0;
    public OccurrenceCount = 1;
    public StartedAt: Date | null = null;
    public AcknowledgedBy = "";
    public ResolvedBy = "";

    constructor(dto?: any) {
        if (!dto) return;
        this.AlertIncidentId = Number(dto.alertIncidentId ?? 0);
        this.DefinitionCode = dto.definitionCode ?? "";
        this.Severity = Number(dto.severity ?? 0);
        this.Summary = dto.summary ?? "";
        this.State = Number(dto.state ?? 1);
        this.EscalationLevel = Number(dto.escalationLevel ?? 0);
        this.OccurrenceCount = Number(dto.occurrenceCount ?? 1);
        this.StartedAt = tsToDate(dto.startedAt);
        this.AcknowledgedBy = dto.acknowledgedBy ?? "";
        this.ResolvedBy = dto.resolvedBy ?? "";
    }

    get SeverityLabel(): string { return SEVERITY_LABELS[this.Severity] ?? ""; }
    get SeverityStyle(): string { return SEVERITY_STYLES[this.Severity] ?? "bg-gray-100 text-gray-700"; }
    get CanAcknowledge(): boolean { return this.State === eAlertIncidentState.ALERT_INCIDENT_STATE_OPEN || this.State === eAlertIncidentState.ALERT_INCIDENT_STATE_ESCALATED; }
    get CanResolve(): boolean { return this.State !== eAlertIncidentState.ALERT_INCIDENT_STATE_RESOLVED; }
}
